export const getVimeoUrl = (id: string): string =>
  `https://player.vimeo.com/video/${id}?byline=0&dnt=1&pip=0&title=0&controls=1`;
